import { render, staticRenderFns } from "./DisplaySizeForm.vue?vue&type=template&id=55722264&"
import script from "./DisplaySizeForm.vue?vue&type=script&lang=js&"
export * from "./DisplaySizeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports